module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAmBAMAAABJxLRpAAAAMFBMVEUAAADw8PDw8PDw8PDw8PDw8PDw8PDw8PDy8vLy8vLy8vLx8fHx8fHx8fHx8fHx8fHEtTZQAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAApUlEQVQoz2NgoBLgOgMDExgYeOAcBt7/MLCBgYEfzhnB4gtwiE/AId6AQzwBh7gBDnEGGoj/Qoj/Qhb/ghD/hCz+gYE1LQ3GZGBgQ+YwQJgXwMmJBcIpADJZIUwBsDgv3A0wQyHJTx7uBob7YOZHiDjCeB54rCD0BjAwMP5HMgZq61+ERR+QlT9AiAswoDmBF0k5VPwCXPwvA5L4T4RHDJDFwUYCAH2IO2MVrb2bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/zhuangshi1.png
// module id = idoa
// module chunks = 69